// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsent_root__CW6g2"};